import type {
  PlayerHistoryDrawerAutotadesColumns,
  PlayerHistoryDrawerTadesColumns
} from '@library/types/trading';
import type { TableColumn } from '@library/types/utils';

export const AUTOTRADE_HEADER: Array<
  TableColumn<PlayerHistoryDrawerAutotadesColumns>
> = [
  {
    column: 'status',
    essential: true,
    label: 'Status',
    sortEnabled: false,
    width: 'w-2/12'
  },
  {
    column: 'trade_reason',
    essential: true,
    label: 'Reason',
    sortEnabled: false,
    width: 'w-3/12'
  },
  {
    column: 'line_score',
    essential: true,
    label: 'Projection Value',
    sortEnabled: false,
    width: 'w-2/12'
  },
  {
    column: 'probability_of_more',
    essential: true,
    label: 'Probability of More',
    sortEnabled: false,
    width: 'w-2/12'
  },
  {
    column: 'applied_at',
    essential: true,
    label: 'Timestamp',
    sortEnabled: false,
    width: 'w-2/12'
  },
  {
    column: 'data_source',
    essential: false,
    label: 'Data Source',
    sortEnabled: false,
    width: 'w-1/12'
  }
];

export const TRADE_HEADER: Array<TableColumn<PlayerHistoryDrawerTadesColumns>> =
  [
    {
      column: 'user_email',
      essential: true,
      label: 'Source',
      sortEnabled: false,
      width: 'w-1/6'
    },
    {
      column: 'comment',
      essential: true,
      label: 'Reason',
      sortEnabled: false,
      width: 'w-2/6'
    },
    {
      column: 'audited_changes',
      essential: true,
      label: 'Changes',
      sortEnabled: false,
      width: 'w-2/6'
    },
    {
      column: 'created_at',
      essential: true,
      label: 'Timestamp',
      sortEnabled: false,
      width: 'w-1/6'
    }
  ];
